import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface AccessGroupConfirmationCardProps {
  description?: string;
  member_count?: number;
  name?: string;
}

export const AccessGroupConfirmationCard = ({
  name,
  description,
  member_count,
}: AccessGroupConfirmationCardProps) => {
  const membersText =
    member_count != null
      ? t("help_widget.copilot.confirmation_card.members_count", {
          count: member_count,
        })
      : undefined;

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.access_group_title")}
      attributes={[
        {
          label: t("help_widget.copilot.confirmation_card.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.confirmation_card.description"),
          value: description,
        },
        {
          label: t("help_widget.copilot.confirmation_card.number_of_members"),
          value: membersText,
        },
      ]}
    />
  );
};
